export default __webpack_public_path__ + "static/media/ad_weboffice_en_300x250@2x.08c502fc.png";